import { html, on, rune, View } from 'rune-ts';
import klass from './CreatorInputTextArea.module.scss';
import { typo, typoPcMo } from '../../../../../shared/typography/typo';
import { MarkIcon } from '../../../../../shared/components/atoms/Icon';

export class CreatorInputTextArea extends View {
  is_validate = false;
  text_value = '';

  constructor() {
    super({});
  }

  override template() {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    return html`
      <div class="${klass.form_item}">
        <label
          class="${klass.form_label} ${typoPcMo({
            is_mobile,
            pc: '16_bold',
            mo: '14_bold',
          })} required"
          for="creator_advance_reservation_introduce_input"
        >
          <div>${ET('mps2::ad_res::introduce')}</div>
          <div class="${klass.mark}">${MarkIcon}</div>
        </label>
        <textarea
          type="textarea"
          id="creator_advance_reservation_introduce_input"
          class="${klass.form_control}"
          placeholder="${ET('mps2::ad_res::introduce_placeholder')}"
          name="description"
          maxlength="200"
        ></textarea>
        <span class="${klass.form_count}">
          <span class="form_count_number">0</span>
          <span>/ 200${ET('mps2::ad_res::letter_count')}</span>
        </span>
        <p class="${klass.form_desc_hidden} textarea_desc ${typo('12_medium')}">
          ${ET('mps2::ad_res::introduce_error')}
        </p>
      </div>
    `;
  }

  @on('keyup', 'textarea[name="description"]')
  countText(e) {
    const $textarea = e.currentTarget;
    const $textarea_count = this.element().querySelector('.form_count_number');
    const $textarea_desc = this.element().querySelector('.textarea_desc');

    if ($textarea_count) {
      $textarea_count.innerHTML = $textarea.value.length;
    }

    if ($textarea.value.length > 200) {
      $textarea.classList.add(`${klass.invalid}`);
      $textarea_desc?.classList.add(`${klass.invalid}`);
      this.is_validate = false;
      return;
    }

    $textarea.classList.remove(`${klass.invalid}`);
    $textarea_desc?.classList.remove(`${klass.invalid}`);
    this.is_validate = true;
    this.text_value = e.target.value;
  }

  getValue() {
    return this.text_value;
  }

  isValidate() {
    return this.is_validate;
  }
}
